/* eslint-disable camelcase */
import {
  MODIFY_HELP_SUMMARY, MODIFY_HELP_DESCRIPTION, MODIFY_HELP_ATTACHMENTS, MODIFY_HELP_CLASSIFICATION, MODIFY_HELP_HARDWARE,
  MODIFY_HELP_SOFTWARE, MODIFY_HELP_VEHICLES, MODIFY_HELP_PARTIES, MODIFY_HELP_RECIPIENTS, MODIFY_HELP_TRANSLATIONS, MODIFY_HELP,
  MODIFY_HELP_AREA, MODIFY_HELP_FEEDBACK, MODIFY_HELP_SUMMARY_FEEDBACK, MODIFY_HELP_SUMMARY_PLANT_FEEDBACK,
} from '../types';

const initialState = {
  summary: {},
  description: {},
  attachments: {},
  classification: {},
  affectedHardware: {},
  affectedSoftware: {},
  affectedVehicles: {},
  involvedParties: {},
  recipients: {},
  translations: {},
  feedback: {},
  summaryFeedback: {},
  summaryPlantFeedback: {},
};

export default (state = initialState, action) => {
  let newState = {};

  switch (action.type) {
    case MODIFY_HELP_SUMMARY:
      newState = { summary: action.payload };
      break;
    case MODIFY_HELP_DESCRIPTION:
      newState = { description: action.payload };
      break;
    case MODIFY_HELP_ATTACHMENTS:
      newState = { attachments: action.payload };
      break;
    case MODIFY_HELP_CLASSIFICATION:
      newState = { classification: action.payload };
      break;
    case MODIFY_HELP_HARDWARE:
      newState = { affectedHardware: action.payload };
      break;
    case MODIFY_HELP_SOFTWARE:
      newState = { affectedSoftware: action.payload };
      break;
    case MODIFY_HELP_VEHICLES:
      newState = { affectedVehicles: action.payload };
      break;
    case MODIFY_HELP_PARTIES:
      newState = { involvedParties: action.payload };
      break;
    case MODIFY_HELP_RECIPIENTS:
      newState = { recipients: action.payload };
      break;
    case MODIFY_HELP_TRANSLATIONS:
      newState = { translations: action.payload };
      break;
    case MODIFY_HELP_SUMMARY_FEEDBACK:
      newState = { summaryFeedback: action.payload };
      break;
    case MODIFY_HELP_SUMMARY_PLANT_FEEDBACK:
      newState = { summaryPlantFeedback: action.payload };
      break;
    case MODIFY_HELP:
      newState = {
        ...action.payload,
        affectedHardware: action.payload?.affected_hardware,
        affectedSoftware: action.payload?.affected_software,
        affectedVehicles: action.payload?.affected_vehicles,
        involvedParties: action.payload?.involved_parties,
        summaryFeedback: action.payload?.summary_feedback,
        summaryPlantFeedback: action.payload?.summary_plant_feedback,
      };
      break;
    case MODIFY_HELP_AREA:
      newState = { focus: action.payload };
      break;
    case MODIFY_HELP_FEEDBACK:
      newState = { feedback: action.payload };
      break;
    default:
      newState = {};
  }

  return {
    ...state,
    ...newState,
  };
};

export const getHelp = (state) => state.helpReducer;
export const getHelpSummary = (state) => state.helpReducer.summary;
export const getHelpDescription = (state) => state.helpReducer.description;
export const getHelpAttachments = (state) => state.helpReducer.attachments;
export const getHelpClassification = (state) => state.helpReducer.classification;
export const getHelpHardware = (state) => state.helpReducer.affectedHardware;
export const getHelpSoftware = (state) => state.helpReducer.affectedSoftware;
export const getHelpVehicles = (state) => state.helpReducer.affectedVehicles;
export const getHelpInvolvedParties = (state) => state.helpReducer.involvedParties;
export const getHelpRecipients = (state) => state.helpReducer.recipients;
export const getHelpTranslations = (state) => state.helpReducer.translations;
export const getHelpFeedback = (state) => state.helpReducer.feedback;
export const getHelpSummaryFeedback = (state) => state.helpReducer.summaryFeedback;
export const getHelpSummaryPlantFeedback = (state) => state.helpReducer.summaryPlantFeedback;
